import React from 'react';
import './index.scss';
import { createRoot } from 'react-dom/client';

import { App } from './app';
import { CookieProvider } from './context';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root');

if (rootElement) {
  const root = createRoot(rootElement); // Create a root for React 18+
  root.render(
    <React.StrictMode>
      <CookieProvider>
        <App />
      </CookieProvider>
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
